import {
  EarningsInsight,
  EarningsInsightFilterResponse,
  EarningsInsightsFilterRequest,
  earningsInsights,
} from '@api';
import { deduplicateEarningsInsights } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter.utils';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';
import { getKgEarningsInsightsForChart } from './kg-insights-service';

const getEarningsInsightsFilter = async (
  payload: EarningsInsightsFilterRequest
) => {
  const { path, schema } = earningsInsights.postEarningsInsightFilter;

  return await apiFetch<EarningsInsightFilterResponse>(path, {
    method: 'post',
    body: payload,
    schema,
  });
};

export const getEarningsInsightsForChart = async (
  payload: EarningsInsightsFilterRequest,
  includeKg = false
): Promise<EarningsInsight[]> => {
  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as EarningsInsightsFilterRequest;

  const [earningsInsightsResponse, kgEarningsInsightsResponse] =
    await Promise.allSettled([
      getEarningsInsightsFilter(cleanedPayload),
      includeKg
        ? getKgEarningsInsightsForChart(cleanedPayload)
        : Promise.resolve({ data: [] as EarningsInsight[] }),
    ]);

  const kgEarningsInsightsData =
    kgEarningsInsightsResponse.status === 'fulfilled'
      ? (kgEarningsInsightsResponse.value.data ?? [])
      : [];
  const earningsInsightsData =
    earningsInsightsResponse.status === 'fulfilled'
      ? (earningsInsightsResponse.value.data ?? [])
      : [];

  return deduplicateEarningsInsights([
    ...kgEarningsInsightsData,
    ...earningsInsightsData,
  ]);
};
